import { useFocusEffect } from "@react-navigation/native";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";

import { useWithAppState } from "@towersystems/roam-common-native";

import { useCallback, useEffect } from "react";
import { ModalCloseButton } from "@towersystems/roam-common-native";
import { RootDrawerToggle } from "@towersystems/roam-common-native";
import { ShiftRootParamList, ValidSetupRootParamList } from "../../../../types";
import { useActiveTerminal } from "../../../../utilities/app-state/hooks";
import { useSetupAllStartupEntities } from "../../../../utilities/setup";
import { EndOfShiftContext } from "../../utils/shift/context";
import { AddCashToOpenShiftScreen } from "../AddCashToOpenShiftScreen";
import { ClosedShiftSummaryScreen } from "../ClosedShiftSummaryScreen";
import { CloseShiftRootScreen } from "../CloseShiftRootScreen";
import { OpenShiftScreen } from "../OpenShiftScreen";
import { RemoveCashFromOpenShiftScreen } from "../RemoveCashFromOpenShiftScreen";
import { ShiftHistoryScreen } from "../ShiftHistoryScreen";
import { ShiftLandingScreen } from "../ShiftLandingScreen";
import { StartNewShiftScreen } from "../StartNewShiftScreen";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { ShiftSendReportModalScreen } from "../ShiftSendReportModalScreen";
import { AiInsightsRootModalScreen } from "../../../point-of-sale/screens/AiInsightsScreens/AiInsightsRootModalScreen";
import { Colors } from "react-native-ui-lib";

export interface ShiftRootScreenProps
  extends StackScreenProps<ValidSetupRootParamList, "ShiftRootScreen"> {}

export const ShiftRootScreen = ({ navigation }: ShiftRootScreenProps) => {
  const { fetchAndSyncEntity } = useSetupAllStartupEntities();
  const { terminal } = useActiveTerminal();
  const { appState } = useWithAppState();
  const ShiftDrawer = createStackHeaderNavigator<ShiftRootParamList>();

  useFocusEffect(
    useCallback(() => {
      fetchAndSyncEntity("terminals");
    }, [])
  );

  useEffect(() => {
    if (!appState.terminalId) {
      navigation.navigate("RegisterRootScreen", {
        screen: "SellScreen",
      });
    }
  }, [appState.terminalId]);

  if (!terminal) {
    return null;
  }

  return (
    <EndOfShiftContext.Provider value={{ shiftTerminal: terminal }}>
      <ShiftDrawer.Navigator
        screenOptions={{
          title: "",
        }}
      >
        <ShiftDrawer.Group
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerLeft: () => <RootDrawerToggle />,
          }}
        >
          <ShiftDrawer.Screen
            name="ShiftLandingScreen"
            component={ShiftLandingScreen}
          />
        </ShiftDrawer.Group>
        <ShiftDrawer.Group
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        >
          <ShiftDrawer.Screen
            name="StartNewShiftScreen"
            component={StartNewShiftScreen}
          />
          <ShiftDrawer.Screen
            name="ShiftHistoryScreen"
            component={ShiftHistoryScreen}
          />
          <ShiftDrawer.Screen
            name="OpenShiftScreen"
            component={OpenShiftScreen}
          />
          <ShiftDrawer.Screen
            name="CloseShiftRootScreen"
            component={CloseShiftRootScreen}
            options={{ headerShown: false }}
          />
          <ShiftDrawer.Screen
            name="ClosedShiftSummaryScreen"
            component={ClosedShiftSummaryScreen}
          />
        </ShiftDrawer.Group>

        <ShiftDrawer.Group
          screenOptions={{
            presentation: "modal",
            animationEnabled: true,
            headerLeft: () => <ModalCloseButton type="Close" />,
          }}
        >
          <ShiftDrawer.Screen
            name="AddCashToOpenShiftScreen"
            component={AddCashToOpenShiftScreen}
            options={{ title: "Add Cash" }}
          />
          <ShiftDrawer.Screen
            name="RemoveCashFromOpenShiftScreen"
            component={RemoveCashFromOpenShiftScreen}
            options={{ title: "Remove Cash" }}
          />

          <ShiftDrawer.Screen
            name="ShiftSendReportModalScreen"
            component={ShiftSendReportModalScreen}
            options={{ title: "Email Report" }}
          />
        </ShiftDrawer.Group>
        <ShiftDrawer.Group
          screenOptions={{
            headerLeft: () => <ModalCloseButton />,
            animationEnabled: true,
            headerShown: true,
            presentation: "modal",
            title: "",
            cardStyle: { backgroundColor: Colors.surface },
          }}
        >
          <ShiftDrawer.Screen
            name="AiInsightsRootModalScreen"
            component={AiInsightsRootModalScreen}
            options={{ headerShown: false }}
          />
        </ShiftDrawer.Group>
      </ShiftDrawer.Navigator>
    </EndOfShiftContext.Provider>
  );
};
